import { styled } from 'parkdepot-shared/theme'

export const CardContainer = styled<'button', { $isLast?: boolean; $disabled?: boolean; $loading?: boolean }>(
    'button',
    ({ $theme, $isLast = true, $disabled = false }) => ({
        backgroundColor: $disabled ? $theme.colors.mono200 : '#fff',
        borderRadius: '1.4rem',
        padding: '2rem 3rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flexs-start',
        marginBottom: $isLast ? '0px' : '2rem',
        cursor: $disabled ? 'not-allowed' : 'pointer',
        border: `1px solid ${$theme.colors.mono300}`,
        gap: $theme.sizing.scale800,
        textAlign: 'left',
        width: '100%',
        pointerEvents: $disabled ? 'none' : 'auto',
        opacity: $disabled ? 0.4 : 1,
        position: 'relative'
    })
)

export const CardHeader = styled('div', () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
}))

export const CardHeaderText = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    margin: 0,
    color: $theme.colors.black
}))

export const CardBody = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: $theme.sizing.scale100,
    width: '100%',
    alignItems: 'flex-start',
    color: $theme.colors.black
}))

export const CardBodyInner = styled('div', () => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'flex-start'
}))

export const SpinnerContainer = styled('div', () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    left: 0,
    bottom: 0,
    right: 0,
    top: 0,
    position: 'absolute',
    backgroundColor: '#F5F5F5',
    overflow: 'hidden',
    borderRadius: '1.4rem'
}))

export const FreeParkingCardContainer = styled('div', ({ $theme }) => ({
    backgroundColor: '#fff',
    gap: '2rem',
    borderRadius: '1.4rem',
    padding: '4rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flexs-start',
    border: `1px solid ${$theme.colors.mono300}`,
    width: '100%',
    position: 'relative'
}))
